import {
  ModalAction,
  ModalLeftAlignedAction,
  ModalRightAlignedAction
} from '../styled-components'
import ButtonComponent from '../../button'
import { buttonSizeOptions, buttonVariantOptions } from '../../button/constants'
import PropTypes from 'prop-types'

const ModalActions = ({
  rightButtons = [],
  leftButtons = [],
  textLinkButton = {}
}) => {
  const renderButtons = (buttons = []) =>
    buttons.map((button, index) => {
      const { title = '', action } = button

      const handleOnClick = (event) => {
        if (action) action(event)
      }

      return (
        <ButtonComponent
          key={`${title}-${index}`}
          variant={buttonVariantOptions.PRIMARY}
          size={buttonSizeOptions.MEDIUM}
          onClick={handleOnClick}
          {...button}
        >
          {title}
        </ButtonComponent>
      )
    })

  return (
    <ModalAction>
      <ModalLeftAlignedAction>
        {textLinkButton && (
          <ButtonComponent
            variant={buttonVariantOptions.LINK}
            size={buttonSizeOptions.LARGE}
            to={textLinkButton.to ?? ''}
            emphasis={textLinkButton.emphasis}
            style={{ alignContent: 'center' }}
          >
            {textLinkButton.title ?? ''}
          </ButtonComponent>
        )}
        {renderButtons(leftButtons)}
      </ModalLeftAlignedAction>
      <ModalRightAlignedAction>
        {renderButtons(rightButtons)}
      </ModalRightAlignedAction>
    </ModalAction>
  )
}

const ButtonDataPropType = PropTypes.shape({
  title: PropTypes.string,
  action: PropTypes.func,
  variant: PropTypes.string
})

ModalActions.propTypes = {
  rightButtons: PropTypes.arrayOf(ButtonDataPropType),
  leftButtons: PropTypes.arrayOf(ButtonDataPropType),
  textLinkButton: PropTypes.shape({
    title: PropTypes.string,
    to: PropTypes.string,
    emphasis: PropTypes.string
  })
}

export default ModalActions
